export const GET_SWAP_RATE_DET='GET_SWAP_RATE_DET';
export const GET_SWAP_RATE_DET_SUCCESS='GET_SWAP_RATE_DET_SUCCESS';
export const GET_SWAP_RATE_DET_FAILURE='GET_SWAP_RATE_DET_FAILURE';
export const UPDATE_SWAP_RATE_DET='UPDATE_SWAP_RATE_DET';
